module.exports = __webpack_public_path__ + "static/media/ios-13-step-2.4d611466.jpeg";